import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { get } from "../Services/LocalStorageService";

const AppointmentGuard = ({ children }) => {
  const AuthUserData = useSelector((state) => state.authUser);
  const location = useLocation();

  if (!AuthUserData.isAuthenticated && !get("TOKEN_USER")) {
    // Store the intended path and its state so Login can redirect back
    sessionStorage.setItem("redirectAfterLogin", location.pathname);
    sessionStorage.setItem("redirectAfterLoginState", JSON.stringify(location.state || {}));
    return <Navigate to="/user-login" replace />;
  }

  return children;
};

export default AppointmentGuard;
